import React, { useEffect, useMemo, useState } from "react";
import { useParams } from "react-router-dom";
import { Container } from "@material-ui/core";
import PageBackground from "../../organisms/PageBackground";
import { Button } from "@thrivetribe/gloji.ui.atoms.button";
import { PageTitle } from "@thrivetribe/gloji.ui.molecules.page-title";
import { MINT } from "@thrivetribe/gloji.enums.brand-colors";
import { Helmet } from "react-helmet";
import Toast from "../../atoms/Toast";
import { myProgressBg } from "../../../assets/img/bg";
import { useDispatch, useSelector } from "react-redux";
import { get_all_weights } from "../../../store/actions/getAllWeights";
import { fetchSmokingLogs } from "../../../store/actions/fetchSmokingLogs";
import useUser from "../../hooks/useUser";
import AlreadyLoggedWeightToday from "../../atoms/AlreadyLoggedWeightToday";
import { CustomModal, ModalContent, ModalTitle, ModalCloseButton } from "../../organisms/CustomModal";
import "./MyProgress.scss";
import LogWeightForm from "../../molecules/LogWeightForm";
import { log_weight_error_reset, log_weight_success_reset } from "../../../store/actions/postWeight";
import GraphWithHeaderFooter from "@thrivetribe/gloji.ui.organisms.graph-with-header-footer";
import { profileService, featureService, healthMetricService } from "../../services";
import Pathway from "../../../enums/profile/Pathway";

import { weightTypes } from "../../../enums/weightTypes";
import { useCurrentJourney } from "../../hooks/useCurrentJourney";
import useUserId from "../../hooks/useUserId";
import { useGetProfileByIdQuery } from "../../../redux/profileApiV3";
import { skipToken } from "@reduxjs/toolkit/dist/query/react";
import { Tabs } from "@thrivetribe/gloji.ui.molecules.tabs";
import useFeatureFlag from "../../hooks/useFeatureFlag";
import Features from "../../../enums/features";
import { ReactComponent as CelebrationIcon } from "../../../assets/img/celebration.svg";
import { ReactComponent as SmokeFreeIcon } from "../../../assets/img/smoke-free-icon.svg";
import { TopRightModalCloseButton } from "../../atoms/TopRightModalCloseButton";
import dayjs from "dayjs";
import isSameOrBefore from "dayjs/plugin/isSameOrBefore";
import { ModalPageFooter, ModalPageBody, ModalPageWrapper } from "../../organisms/ModalPage";
import { SmokingCalendar } from "../../molecules/SmokingCalendar/SmokingCalendar";
import { logException } from "../../../utils/AppInsightsLogging";
import PropTypes from "prop-types";
import classNames from "classnames";

import CustomCalendar from "../../molecules/CustomCalendar";
import { loseWeightCardData, smokeFreeCardData } from "../../../data/Programme/Programmes";



dayjs.extend(isSameOrBefore);

const MyProgress = () => {
  const { programmeSlug } = useParams();
  const [user] = useUser();
  const [userId] = useUserId();
  const [open, setOpen] = useState(false);
  const [readyToGoModalOpen, setReadyToGoModalOpen] = useState(false);
  const [awesomeModalOpen, setAwesomeModalOpen] = useState(false);
  const [smokedTodayModalOpen, setSmokedTodayModalOpen] = useState(false);
  const [smokedAlreadyLoggedModalOpen, setSmokedAlreadyLoggedModalOpen] = useState(false);
  const [firstsmokedTodayModalOpen, setFirstsmokedTodayModalOpen] = useState(false);
  const [smokedYouveGotThisModalOpen, setSmokedYouveGotThisModalOpen] = useState(false);
  const [weightLogSuccessful, setWeightLogSuccessful] = useState(false);
  const [introActive, setIntroActive] = useState(false);
  const [journeyReady, setJourneyReady] = useState(false);
  const [handelSmokeFirstEntryModel, setHandelSmokeFirstEntryModel] = useState(false);
  const [isSmokeFreeStreakModalOpen, setIsSmokeFreeStreakModalOpen] = useState(false);
  const [programmeWeights, setProgrammeWeights] = useState([]);
  const [tabs, setTabs] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const [dateValue, setDateValue] = useState(null);
  const [calendarError, setCalendarError] = useState(false);

  const [startDate, setStartDate] = useState(new Date());

  const minDate = new Date(2020, 0, 1);
  const maxDate = new Date();

  const allWeights = useSelector(state => state.allWeights);
  const allSmokingLogs = useSelector(state => state.allSmokingLogs);

  const profileQuery = useGetProfileByIdQuery(userId ?? skipToken);
  const weightLogging = useSelector(state => state.weightLogging);
  const dispatch = useDispatch();

  const [firstTimeWeightLogged, setFirstTimeWeightLogged] = useState(false);
  const [firstTimeSmokeLogged, setFirstTimeSmokeLogged] = useState(false);
  const [justCompletedFirstLog, setJustCompletedFirstLog] = useState(false);
  const [displayWeightWarning, setDisplayWeightWarning] = useState(false);

  const [configTrackSmokeFreeEnabled, configTrackSmokeFreeReady] = useFeatureFlag(
    Features.TRACK_SMOKE_FREE,
    featureService.isFeatureEnabled,
    true
  );

  const { data: profile, isSuccess: profileIsSuccess } = profileQuery;
  const journey = useCurrentJourney(profileQuery, programmeSlug);

  useEffect(() => {
    const userProgrammes = profile?.pastAndCurrentProgrammeIds || [];
    if (userProgrammes.includes(loseWeightCardData.programmeId) && journey) {
      setJourneyReady(true);
    }
  }, [journey]);

  useEffect(
    () => {
      const userProgrammes = profile?.pastAndCurrentProgrammeIds || [];
      if (userProgrammes.includes(loseWeightCardData.programmeId)) {
        if (journey?.flags?.initialWeightLogged === true) {
          setFirstTimeWeightLogged(false);
          setIntroActive(false);
        } else {
          setFirstTimeWeightLogged(true);
          setIntroActive(true);
        }
      }
      if (userProgrammes.includes(smokeFreeCardData.programmeId)) {
        if (journey?.flags?.initialWeightLogged) {
          setFirstTimeSmokeLogged(false);
        } else {
          setFirstTimeSmokeLogged(true);
        }      
      }
    },
    [journey],
    allSmokingLogs.data
  );

  useEffect(() => {
    if (journey) {
      dispatch(get_all_weights(userId, journey?.id));
    }
  }, [dispatch, journey, userId]);

  useEffect(() => {
    if (userId) {
      dispatch(fetchSmokingLogs(userId));
    }
  }, [dispatch, userId]);

  // Modal functions
  const handleShowModal = () => {
    setOpen(true);
    document.getElementById("root").classList.add("modal-active");
  };

  //Handle display of Lose Weight/Smoke free tabs
  useEffect(() => {
    if (
      !configTrackSmokeFreeEnabled ||
      !configTrackSmokeFreeReady ||
      !profileIsSuccess ||
      !profile?.pastAndCurrentProgrammeIds
    ) {
      return;
    }
    const userProgrammes = profile?.pastAndCurrentProgrammeIds || [];
    const tabData = [];

    if (userProgrammes.includes(loseWeightCardData.programmeId)) {
      tabData.push({
        title: "Lose weight",
        children: (
          <div className="progress__tabs" id="lose-weight-tab">
            <GraphWithHeaderFooter
              dataLoading={allWeights.loading}
              chartData={programmeWeights}
              isAdvisorView={false}
              firstName={user.given_name}
              handleLogWeight={handleLogWeight}
              buttonText={firstTimeWeightLogged ? "All done! Let's move on" : undefined}
              buttonStyle={firstTimeWeightLogged ? "primary" : undefined}
            />
          </div>
        ),
      });
    }

    if (userProgrammes.includes(smokeFreeCardData.programmeId)) {
      tabData.push({
        title: "Smoke free",
        children: (
          <SmokeFreeTab
            userName={user.given_name}
            onLogProgressClick={() => {
              if (justCompletedFirstLog) {
                setReadyToGoModalOpen(true);
                setJustCompletedFirstLog(false);
                return;
              }

              const logs = allSmokingLogs?.data;

              if (!Array.isArray(logs) || logs.length === 0) {
                setFirstsmokedTodayModalOpen(true);
                return;
              }

              const today = new Date().toISOString().split("T")[0];
              const hasSmokedEntry = logs.find(entry => entry.date?.startsWith(today));

              if (!hasSmokedEntry || typeof hasSmokedEntry.hasSmoked !== "boolean") {
                setSmokedTodayModalOpen(true);
              } else {
                setSmokedAlreadyLoggedModalOpen(true);
              }
            }}
            profileQueryData={profileQuery}
            userSmokingLogs={allSmokingLogs?.data}
            firstTimeSmokeLogged={firstTimeSmokeLogged}
            justCompletedFirstLog={justCompletedFirstLog}
          />
        ),
      });
    }

    setTabs(tabData);
  }, [
    profile,
    profileIsSuccess,
    configTrackSmokeFreeReady,
    configTrackSmokeFreeEnabled,
    allWeights.data,
    allWeights.loading,
    allSmokingLogs.data,
    allSmokingLogs.loading,
    firstTimeWeightLogged,
    firstTimeSmokeLogged,
    user.given_name,
    programmeWeights,
  ]);

  const handleLogWeight = async () => {
    if (!firstTimeWeightLogged) {
      return handleShowModal();
    }

    const payload = {
      step0Completed: true,
      initialWeightLogged: true,
      appointmentBooked: false,
    };
    await profileService.setJourneyFlags(userId, journey.id, payload);

    if (journey?.pathway === Pathway.SUPPORTED) {
      setAwesomeModalOpen(true);
    } else {
      setReadyToGoModalOpen(true);
    }
  };

  const handleModalClose = () => {
    setOpen(false);
    setReadyToGoModalOpen(false);
    setAwesomeModalOpen(false);
    setDisplayWeightWarning(false);
    setSmokedTodayModalOpen(false);
    setSmokedAlreadyLoggedModalOpen(false);
    setFirstsmokedTodayModalOpen(false);
    setSmokedYouveGotThisModalOpen(false);
    setHandelSmokeFirstEntryModel(false);
    setIsSmokeFreeStreakModalOpen(false);
    setDateValue(null);
    setCalendarError(false);
    document.getElementById("root").classList.remove("modal-active");
    dispatch(get_all_weights(userId, journey?.id));
    dispatch(log_weight_success_reset());
    dispatch(log_weight_error_reset());
  };

  const handleCalendarClose = () => {
    setHandelSmokeFirstEntryModel(false); // Close the modal
  };

  const handleCalendarSubmit = () => {
    if (dateValue) {
      setHandelSmokeFirstEntryModel(false);
    }
  };

  const showSuccessMessage = () => {
    setWeightLogSuccessful(true);
  };

  const handleSuccessMessageClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }
    setWeightLogSuccessful(false);
    setDisplayWeightWarning(false);
  };

  useEffect(() => {
    if (weightLogging.data.length !== 0) setIntroActive(false);
  }, [weightLogging.data]);

  useEffect(() => {
    if (allWeights?.data?.weights === undefined || allWeights?.data?.weights.length === 0) return;

    const programmeWeights = allWeights.data.weights
      .filter(weight => weight.weightType === weightTypes.PROGRAMME || weight.weightType === null)
      .map(weight => ({ ...weight }));

    setProgrammeWeights(programmeWeights);
  }, [allWeights.data]);

  const handleReturnMyPath = () => {
    return (window.location.href = `/my-path/${programmeSlug}`);
  };

  const handleReturnHome = () => {
    handleModalClose();
    return (window.location.href = "/");
  };

  const handleLogSmokedToday = async () => {
    const payload = {
      step0Completed: true,
      initialWeightLogged: true,
    };
    await profileService.setJourneyFlags(userId, journey.id, payload);
    if (!journey?.flags?.initialWeightLogged) {
      setFirstTimeSmokeLogged(false);
      setJustCompletedFirstLog(true);
    }
    const todaysDate = dayjs().format("YYYY-MM-DD");

    let requestPayload = {
      userId: userId,
      date: todaysDate,
      hasSmoked: true,
    };

    try {
      await healthMetricService.logSmokedToday(userId, requestPayload);
      await dispatch(fetchSmokingLogs(userId));
      handleModalClose();
      setSmokedYouveGotThisModalOpen(true);
    } catch (error) {
      logException("Error logging smoking progress:", error);
    }
  };

  const handleLogSmokedFromDate = async selectedDate => {
    const payload = {
      step0Completed: true,
      initialWeightLogged: true,
    };
    await profileService.setJourneyFlags(userId, journey.id, payload);
    if (!journey?.flags?.initialWeightLogged) {
      setFirstTimeSmokeLogged(false);
      setJustCompletedFirstLog(true);
    }
    const today = dayjs().startOf("day");
    const startDate = dayjs(selectedDate).startOf("day");

    if (!selectedDate) {
      setCalendarError(true);
      return;
    }

    if (!startDate.isValid() || startDate.isAfter(today)) {
      setCalendarError(true);
      return;
    }
    setCalendarError(false);
    const entries = [];

    entries.push({
      date: startDate.format("YYYY-MM-DD"),
      hasSmoked: true,
    });

    let loopDate = startDate.add(1, "day");
    while (loopDate.isSameOrBefore(today)) {
      entries.push({
        date: loopDate.format("YYYY-MM-DD"),
        hasSmoked: false,
      });
      loopDate = loopDate.add(1, "day");
    }

    try {
      setIsLoading(true);
      for (const entry of entries) {
        await healthMetricService.logSmokedToday(userId, {
          userId,
          date: entry.date,
          hasSmoked: entry.hasSmoked,
        });
      }

      await dispatch(fetchSmokingLogs(userId));
      setIsSmokeFreeStreakModalOpen(true);
      setIsLoading(false);
    
      setIsLoading(false);
    } catch (error) {
      logException("Error logging smoking progress from date:", error);
      setIsLoading(false);
    }
  };

  const handleLogNotSmokedToday = async () => {
    const todaysDate = dayjs().format("YYYY-MM-DD");

    let requestPayload = {
      userId: userId,
      date: todaysDate,
      hasSmoked: false,
    };

    try {
      await healthMetricService.logSmokedToday(userId, requestPayload);
      await dispatch(fetchSmokingLogs(userId));
      handleModalClose();
      setIsSmokeFreeStreakModalOpen(true);
    } catch (error) {
      logException("Error logging smoking progress:", error);
    }
  };

  const handlelastsmoked = async () => {
    handleModalClose();
    setHandelSmokeFirstEntryModel(true);
  };

  const handleBookAppointment = () => {
    handleModalClose();
    return (window.location = `/book-appointment/${programmeSlug}`);
  };

  const streakAnalysis = useMemo(() => {
    // Sort logs by date to ensure chronological processing
    const sortedLogs = [...allSmokingLogs.data].sort((a, b) => Date.parse(a.date) - Date.parse(b.date));

    let longestStreak = 0;
    let currentStreak = 0;
    let maxStreakEnd = null;
    let currentStreakEnd = null;
    let lastSmokedDate = null;

    // Function to check if a date is a smoking date
    const isSmokingDate = dateString => {
      const log = sortedLogs.find(log => log.date === dateString);
      return !log || log.hasSmoked;
    };

    // Iterate through dates to calculate streaks
    let lastDate = null;
    sortedLogs.forEach((log, index) => {
      const currentDate = new Date(log.date);

      // Track the last date smoked
      if (log.hasSmoked) {
        lastSmokedDate = log.date;
      }

      // If this is not the first log, check for consecutive non-smoking days
      if (lastDate) {
        // Check days between the last log and current log
        let checkDate = new Date(lastDate);
        checkDate.setDate(checkDate.getDate() + 1);

        while (checkDate < currentDate) {
          if (isSmokingDate(checkDate.toISOString().split("T")[0])) {
            // Streak broken
            if (currentStreak > longestStreak) {
              longestStreak = currentStreak;
              maxStreakEnd = lastDate;
            }
            currentStreak = 0;
            break;
          }
          currentStreak++;
          checkDate.setDate(checkDate.getDate() + 1);
        }
      }

      // Process current log
      if (!log.hasSmoked) {
        currentStreak++;
        currentStreakEnd = currentDate;
      } else {
        // Smoking log breaks the streak
        if (currentStreak > longestStreak) {
          longestStreak = currentStreak;
          maxStreakEnd = lastDate;
        }
        currentStreak = 0;
      }

      lastDate = currentDate;
    });

    // Final check for current streak
    if (currentStreak > longestStreak) {
      longestStreak = currentStreak;
      maxStreakEnd = lastDate;
    }

    return {
      longestStreak: longestStreak.toString().padStart(2, "0"),
      currentStreak: currentStreak.toString().padStart(2, "0"),
      longestStreakEnd: maxStreakEnd ? maxStreakEnd.toISOString().split("T")[0] : null,
      currentStreakEnd: currentStreakEnd ? currentStreakEnd.toISOString().split("T")[0] : null,
      lastSmokedDate: lastSmokedDate ? dayjs(lastSmokedDate).format("DD MMM YYYY") : null,
    };
  }, [allSmokingLogs.data]);

  return (
    <PageBackground bgImage="">
      <Helmet>
        <title>My progress | Gloji</title>
      </Helmet>
      <section
        className="my-progress chart-section__container"
        style={{ backgroundImage: `url(${myProgressBg})` }}
      >
        <Container>
          <PageTitle color={MINT}>My progress</PageTitle>
          {introActive && (
            <section className="progress-intro">
              <div className="progress-intro__container">
                <div className="progress-intro__content">
                  <h2>Hi {profileQuery?.data?.personalDetails?.firstName}! Let's start fresh</h2>
                  <p>
                    We're so excited for your new beginning and the chance to change your life for the better.
                  </p>
                  <p>
                    Get the ball rolling and log your weight now, we'll check in and see how you're doing in
                    12 weeks!
                  </p>
                </div>
                <div className="progress-intro__footer">
                  <Button
                    className="progress-intro__footer__button"
                    color="primary"
                    onClick={handleShowModal}
                  >
                    Get Started
                  </Button>
                </div>
              </div>
            </section>
          )}
          {!introActive && (
            <>
              {tabs.length > 0 ? (
                configTrackSmokeFreeReady && configTrackSmokeFreeEnabled && <Tabs tabs={tabs} />
              ) : (
                <GraphWithHeaderFooter
                  dataLoading={allWeights.loading}
                  chartData={programmeWeights}
                  isAdvisorView={false}
                  firstName={user.given_name}
                  handleLogWeight={() => handleLogWeight()}
                  buttonText={firstTimeWeightLogged ? "All done! Let's move on" : undefined}
                  buttonStyle={firstTimeWeightLogged ? "primary" : undefined}
                />
              )}
            </>
          )}
        </Container>
        {allWeights.loading === false && journeyReady && (
          <CustomModal
            open={open}
            onClose={handleModalClose}
            id="logWeightModal"
            modalTitleId="logWeightModalTitle"
            modalDescriptionId=""
            aria-labelledby={"logWeightModalTitle"}
          >
            <ModalContent id="logWeightModalContent" modalTitleId="logWeightModalTitle" modalDescriptionId="">
              <ModalTitle id="logWeightModalTitle">Log my weight</ModalTitle>
              {allWeights.data.weights !== undefined && !firstTimeWeightLogged && (
                <AlreadyLoggedWeightToday allWeights={allWeights.data.weights} />
              )}

              {displayWeightWarning && (
                <div className="logging-status__error">
                  <p id="low-weight-warning">Can you double check? That doesn't look quite right.</p>
                </div>
              )}

              <LogWeightForm
                allWeights={allWeights.data.weights}
                closeModal={handleModalClose}
                onSuccess={showSuccessMessage}
                setDisplayWeightWarning={setDisplayWeightWarning}
                journeyId={journey.id}
              />
            </ModalContent>
            <ModalCloseButton onClick={handleModalClose} />
          </CustomModal>
        )}
        <Toast show={weightLogSuccessful} type="success" handleClose={handleSuccessMessageClose}>
          Your weight was successfully logged!
        </Toast>

        <CustomModal
          open={readyToGoModalOpen}
          onClose={handleModalClose}
          id="readyToGoModal"
          modalTitleId="readyToGoModalTitle"
          modalDescriptionId="readyToGoModalDescription"
          aria-labelledby={"readyToGoModalTitle"}
        >
          <ModalContent id="readyToGoModalContent">
            <div className="celebration-img-container"></div>
            <ModalTitle id="readyToGoModalTitle">Ready to go!</ModalTitle>
            <p className="modal-text" id="readyToGoModalDescription">
              Take the first step on your journey with gloji.
            </p>
            <div id="readyToGoModalButtons">
              <Button
                className="complete-button"
                variant="contained"
                color="primary"
                onClick={handleReturnMyPath}
              >
                Show me my path
              </Button>
              <Button
                className="complete-button"
                variant="contained"
                color="secondary"
                onClick={handleReturnHome}
              >
                Return to home
              </Button>
            </div>
          </ModalContent>
        </CustomModal>

        <CustomModal
          open={awesomeModalOpen}
          onClose={handleModalClose}
          id="awesomeModal"
          modalTitleId="awesomeModalTitle"
          modalDescriptionId="awesomeModalDescription"
          aria-labelledby={"awesomeModalTitle"}
        >
          <ModalContent id="awesomeModalContent">
            <div className="celebration-img-container"></div>
            <ModalTitle id="awesomeModalTitle">Awesome</ModalTitle>
            <p className="modal-text" id="awesomeModalDescription">
              Time to book your first appointment with your gloji Health mentor. They'll be by your side
              supporting you every step of the way.
            </p>
            <div id="awesomeModalButtons">
              <Button
                className="complete-button"
                variant="contained"
                color="primary"
                onClick={handleBookAppointment}
              >
                Let's go!
              </Button>
            </div>
          </ModalContent>
        </CustomModal>

        <CustomModal
          open={smokedTodayModalOpen}
          onClose={handleModalClose}
          id="smokedTodayModal"
          modalTitleId="smokedTodayModalTitle"
          modalDescriptionId="smokedTodayModalDescription"
          aria-labelledby={"smokedTodayModalTitle"}
        >
          <TopRightModalCloseButton onClick={handleModalClose} />
          <ModalContent id="smokedTodayModalContent">
            <ModalTitle id="smokedTodayModalTitle">Smoked Today?</ModalTitle>
            <p className="modal-text" id="smokedTodayModalDescription">
              Build on your smoke free streak or start fresh
            </p>
            <div id="smokedTodayModalButtons">
              <Button
                className="smoked-today-button"
                variant="contained"
                color="secondary"
                onClick={handleLogSmokedToday}
              >
                Yes
              </Button>
              <span className="divider" />
              <Button
                className="smoked-today-button"
                variant="contained"
                color="secondary"
                onClick={handleLogNotSmokedToday}
              >
                No
              </Button>
            </div>
          </ModalContent>
        </CustomModal>

        <CustomModal
          open={firstsmokedTodayModalOpen}
          onClose={handleModalClose}
          id="firstsmokedTodayModal"
          modalTitleId="firstsmokedTodayModalTitle"
          modalDescriptionId="firstsmokedTodayModalDescription"
          aria-labelledby={"firstsmokedTodayModalTitle"}
        >
          <TopRightModalCloseButton onClick={handleModalClose} />
          <ModalContent id="firstsmokedTodayModalContent">
            <ModalTitle id="firstsmokedTodayModalTitle">Smoked Today?</ModalTitle>
            <p className="modal-text" id="smokedTodayModalDescription">
              Make a note of when you last smoked to build on your smoke free streak or start fresh.
            </p>
            <div id="firstsmokedTodayModalButtons">
              <Button
                className="smoked-today-button"
                variant="contained"
                color="secondary"
                onClick={handleLogSmokedToday}
              >
                Yes
              </Button>
              <span className="divider" />
              <Button
                className="smoked-today-button"
                variant="contained"
                color="secondary"
                onClick={handlelastsmoked}
              >
                No
              </Button>
            </div>
          </ModalContent>
        </CustomModal>

        <CustomModal
          open={smokedAlreadyLoggedModalOpen}
          onClose={handleModalClose}
          id="smokedAlreadyLoggedModal"
          modalTitleId="smokedAlreadyLoggedModalTitle"
          modalDescriptionId="smokedAlreadyLoggedModalDescription"
          aria-labelledby="smokedAlreadyLoggedModalTitle"
        >
          <TopRightModalCloseButton onClick={handleModalClose} />

          <ModalContent id="smokedAlreadyLoggedContent" className="smoke-modal-content">
            <h2 id="smokedAlreadyLoggedModalTitle" className="smoke-modal-title">
              Smoked today?
            </h2>

            <div className="smoke-modal-info-box">
              Already logged your progress today? Once a day is plenty. If you log again, this entry will
              replace what you added earlier today.
            </div>

            <p className="smoke-modal-subtext">Build on your smoke free streak or start fresh.</p>

            <div id="smokedAlreadyLoggedModalButtons" className="smoke-modal-buttons">
              <Button
                className="smoked-today-button"
                variant="contained"
                color="secondary"
                onClick={handleLogSmokedToday}
              >
                Yes
              </Button>
              <span className="divider" />
              <Button
                className="smoked-today-button"
                variant="contained"
                color="secondary"
                onClick={handleLogNotSmokedToday}
              >
                No
              </Button>
            </div>
          </ModalContent>
        </CustomModal>

        <CustomModal
          open={smokedYouveGotThisModalOpen}
          onClose={handleModalClose}
          id="smokedYouveGotThisModal"
          modalTitleId="smokedYouveGotThisModalTitle"
          modalDescriptionId="smokedYouveGotThisModalDescription"
          aria-labelledby={"smokedYouveGotThisModalTitle"}
        >
          <ModalContent id="smokedYouveGotThisModalContent">
            <SmokeFreeIcon />
            <ModalTitle id="smokedYouveGotThisModalTitle">You've got this</ModalTitle>
            <p className="modal-text" id="smokedYouveGotThisModalDescription">
              Going smoke free is tough, but we're here to help. Check out our video on{" "}
              <a href="my-path/smoke-free/step-07">overcoming setbacks</a> and{" "}
              <a href="/explore/articles">articles</a> for tips to help you quit.
            </p>
            <div id="smokedYouveGotThisModalButton">
              <Button
                className="return-my-progress-button"
                variant="contained"
                color="primary"
                onClick={handleModalClose}
              >
                Return to My Progress
              </Button>
            </div>
          </ModalContent>
        </CustomModal>

        <CustomModal
          open={handelSmokeFirstEntryModel}
          onClose={handleModalClose}
          id="smokeFirstEntryModal"
          modalTitleId="smokeFirstEntryModalTitle"
          modalDescriptionId="smokeFirstEntryModalDescription"
          aria-labelledby={"smokeFirstEntryModalTitle"}
        >
          <TopRightModalCloseButton onClick={handleModalClose} />
          <ModalContent id="smokeFirstEntryModalContent" className="text-center">
            <ModalTitle id="smokeFirstEntryModalTitle">When did you last smoke?</ModalTitle>

            <div className="flex justify-center mt-4 w-full">
              <div className="smoke-entry__calendar-inner mx-auto w-full max-w-md">
                <CustomCalendar
                  calendarHeader="Select a date"
                  dateValue={dateValue}
                  setDateValue={date => {
                    setDateValue(date);
                    if (calendarError) setCalendarError(false);
                  }}
                  tileClassName={({ date }) => {
                    const isSelected =
                      dayjs(date).format("YYYY-MM-DD") ===
                      dayjs(dateValue).format("YYYY-MM-DD")

                    return classNames("calendar-tile", {
                      "calendar-tile--selected": isSelected,
                    });
                  }}
                  activeStartDate={startDate}
                  onActiveStartDateChange={({ activeStartDate }) => setStartDate(activeStartDate)}
                  disableActionButtons={true}
                  checkDisabledDates={({ date }) => {
                    const today = dayjs().startOf("day").format("YYYY-MM-DD");
                    const current = dayjs(date).startOf("day").format("YYYY-MM-DD");
                    return current === today; // ✅ disables only today
                  }}
                  error={{ present: calendarError, type: "smokeFirstEntrycalendar" }}
                  formatShortWeekday={(_, date) => ["S", "M", "T", "W", "T", "F", "S"][date.getDay()]}
                  minBookingDate={minDate}
                  maxBookingDate={maxDate}
                  closeCalendar={handleCalendarClose}
                  submitCalendar={handleCalendarSubmit}
                />
              </div>
            </div>

            <div className="flex justify-center mt-6">
              <Button
                className="log-progress__button"
                tabIndex="-1"
                color="primary"
                // onClick={() => handleLogSmokedFromDate("2025-07-01")}
                onClick={() => handleLogSmokedFromDate(dateValue)}
                disabled={isLoading}
              >
                {isLoading && <span className="spinner" />}
                Log Progress
              </Button>
            </div>
          </ModalContent>
        </CustomModal>

        <CustomModal
          open={isSmokeFreeStreakModalOpen}
          onClose={handleModalClose}
          id="isSmokeFreeStreakModal"
          modalTitleId="isSmokeFreeStreakModalTitle"
          modalDescriptionId="isSmokeFreeStreakModalDescription"
          aria-labelledby={"isSmokeFreeStreakModalTitle"}
        >
          <ModalContent id="isSmokeFreeStreakModalContent">
            <CelebrationIcon />
            <ModalTitle id="isSmokeFreeStreakModalTitle">You’re doing great!</ModalTitle>
            <p className="modal-text" id="isSmokeFreeStreakModalDescription">
              That’s {streakAnalysis?.currentStreak} day/s smoke free - well done! Come back tomorrow to build
              on your smoke free streak.
            </p>
            <div id="isSmokeFreeStreakModalButton">
              <Button
                className="return-my-progress-button"
                variant="contained"
                color="primary"
                onClick={handleModalClose}
              >
                Return to My Progress
              </Button>
            </div>
          </ModalContent>
        </CustomModal>

      </section>
    </PageBackground>
  );
};

const SmokeFreeTab = ({
  userName,
  onLogProgressClick,
  profileQueryData,
  userSmokingLogs,
  firstTimeSmokeLogged,
  justCompletedFirstLog,
}) => {
  return (
    <ModalPageWrapper className="smoke-free-modal-wrapper">
      <ModalPageBody className="with-sticky-footer">
        <div className="progress__tabs" id="smoke-free-tab">
          {Array.isArray(userSmokingLogs) && userSmokingLogs.length > 0 ? (
            <div>
              <div className="smoke-free-tab__heading">
                Keep going {profileQueryData?.data?.personalDetails?.firstName}!
              </div>
              <SmokingCalendar smokingLogs={userSmokingLogs} />
            </div>
          ) : (
            <div>
              <div className="smoke-free-tab__heading">Hi {userName}! Let’s start fresh</div>
              <div className="smoke-free-tab-content">
                We're so excited for your new beginning and the chance to change your life for the better.
                <br />
                <br />
                Use this tool to keep track of your path to a smoke free you!
                <br />
              </div>
            </div>
          )}
        </div>
      </ModalPageBody>
      <ModalPageFooter hasStickyFooter={false}>
        <Button className="log-progress__button" tabIndex="-1" color="primary" onClick={onLogProgressClick}>
          {justCompletedFirstLog ? "All done! Let's move on" : "Log Progress"}
        </Button>
      </ModalPageFooter>
    </ModalPageWrapper>
  );
};

SmokeFreeTab.propTypes = {
  userName: PropTypes.string.isRequired,
  onLogProgressClick: PropTypes.func.isRequired,
  profileQueryData: PropTypes.object.isRequired,
  userSmokingLogs: PropTypes.array.isRequired,
  firstTimeSmokeLogged: PropTypes.bool.isRequired,
  justCompletedFirstLog: PropTypes.bool.isRequired,
};



export default MyProgress;
